<template>
  <div style="width: 98%; margin: 0 auto">
    <el-form :inline="true" :model="meetingForm" class="demo-form-inline">
      <el-form-item>
        <el-select
          v-model="meetingForm.own_meeting"
          clearable
          size="small"
          style="width: 200px"
          placeholder="与我相关or所有">
          <el-option label="所有会议" value="" />
          <el-option value="1" label="与我相关的会议" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="meetingForm.datatame"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="meetingForm.secrecy_type"
          clearable
          size="small"
          style="width: 180px"
          placeholder="会议保密类型">
          <el-option label="普通会议（非保密）" value="0">普通会议（非保密）</el-option>
          <el-option label="一级会议（保密）" value="1">一级会议（保密）</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="meetingForm.subject"
          clearable
          size="small"
          placeholder="会议主题"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="meetingForm.meeting_no"
          clearable
          size="small"
          placeholder="会议编号"
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="meetingForm.room_id"
          size="small"
          style="width: 200px"
          placeholder="请选择会议室"
          clearable
        >
          <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="isManager == true && meetingForm.own_meeting == ''">
        <el-select
          v-model="meetingForm.attendee"
          :remote-method="filterUser"
          clearable
          filterable
          remote
          size="small"
          placeholder="参会人">
          <el-option
            v-for="(item, index) in userList"
            :key="index"
            :label="item.name + '(' + item.workcode + ')'"
            :value="item.workcode"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-search"
          type="primary"
          @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-download"
          type="success"
          @click="exportAll(true)"
          >全部导出</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-download"
          type="warning"
          @click="exportAll(false)"
          >批量导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" class="tabsBox" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in statusList"
        :key="item.value"
        :label="`${item.statusName}(${status_total[item.statusType]})`"
        :name="item.value"
      />
    </el-tabs>
    <div v-if="meetings.length > 0">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-card
        v-for="(item, index) in meetings"
        :key="index"
        class="box-card"
        style="margin-top: 10px"
        @dblclick.native="checkInfo(item)"
      >
        <div slot="header" class="clearfix">
          <el-checkbox style="margin-right: 10px" v-model="item.isChecked" @change="value => handleCheckedChange(value, item.id)"></el-checkbox>
          <span class="them">( 编号：{{ item.id }} )</span>
          <span class="them" @click="checkInfo(item)">{{
            item.meeting_subject
          }}</span
          >&nbsp;&nbsp;&nbsp;
          <span
            >早会预计时间：{{ item.estimate_start_time }} ~
            {{ item.estimate_end_time }}</span
          >&nbsp;&nbsp;
          <span
            >晚会预计时间：{{ item.night_estart_time }} ~
            {{ item.night_eend_time }}</span
          >&nbsp;&nbsp; <span>最后更新：{{ item.update_time }}</span
          >&nbsp;&nbsp;
        </div>
        <el-row>
          <el-col :span="2" style="min-width: 120px">
            <el-image
              :src="item.room.pictures[0]"
              :preview-src-list="item.room.pictures"
              style="width: 100px; height: 100px"
            />
          </el-col>
          <el-col :span="8">
            <div>
              <span>会议室：{{ item.room_name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >会议地点：{{ item.room_address.city
                }}{{ item.room_address.address }} - {{ item.area }}</span
              >
            </div>
            <p>
              预计参会人数：{{ item.number }}人&nbsp;&nbsp;&nbsp;&nbsp;
              <span>会议类型：{{ item.meeting_type }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >保密类型：{{
                  item.secrecy_type === 1
                    ? "一级会议（保密）"
                    : "普通会议（非保密）"
                }}</span
              >
            </p>
            <p>所属部门：{{ item.secretary_department_name }}</p>
            <p>
              <span>召集人：{{ item.convenor.name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;

              <span>会议秘书：{{ item.secretary.name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span>主持人：{{ item.host.name }}</span>
            </p>
            <span>
              参会者：
              <span v-for="(items, index) in item.attendees" :key="index"
                >{{ items.name }} ,</span>
            </span>
            <p>
              <el-tag
                v-for="(items, index) in item.equipments"
                :key="index"
                type="info"
                size="small"
                effect="plain"
                style="margin-left: 5px"
                >{{ items.equipment_name }}</el-tag
              >
            </p>
          </el-col>
          <el-col v-if="item.isAttendees == true" :span="10">
            <div
              v-if="item.meeting_status != 4 && item.meeting_status != 3"
              class="toolBox">
              <h2 v-for="(item1, index) in h2List" :key="index">
                <span v-show="item.attendees_status == index + 1">
                  {{ item1 }}
                </span>
              </h2>
              <el-button
                v-if="
                  item.meeting_status == 0 &&
                  item.attendees_status != 2 &&
                  item.attendees_status != 4 &&
                  item.secretary.workcode != $store.getters.username &&
                  item.host.workcode != $store.getters.username &&
                  item.convenor.workcode != $store.getters.username
                "
                type="text"
                size="medium"
                @click="attendeesRefuse(item, '0', true)"
                >早会请假</el-button>
              <el-button
                v-if="
                  item.meeting_status == 0 &&
                  item.attendees_status != 4 &&
                  item.attendees_status != 2 &&
                  item.secretary.workcode != $store.getters.username &&
                  item.host.workcode != $store.getters.username &&
                  item.convenor.workcode != $store.getters.username
                "
                type="text"
                size="medium"
                @click="attendeesRefuse(item, '0', false)"
                >早会拒绝</el-button
              >
            </div>
          </el-col>
        </el-row>
        <div class="footer">
          <tags :meeting_status="item.meeting_status"></tags>
          <div style="float: right">
            <el-button
              v-if="
                item.meeting_status == 0 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="meetingstarts(item)"
              >开始早会</el-button
            >
            <el-button
              v-if="
                item.meeting_status == 0 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="endmet(item)"
              >编辑会议</el-button
            >
            <el-button
              v-if="
                item.meeting_status == 0 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="canceltast(item)"
              >取消会议</el-button
            >
            <el-button
              v-if="
                item.meeting_status == 1 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="meetingends(item)"
              >结束早会</el-button
            >
            <el-button type="text" size="medium" @click="checkInfo(item)"
              >查看详情</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
    <el-card
      v-if="meetings.length == 0"
      class="box-card"
      style="margin-top: 10px"
    >
      <div>无数据</div>
    </el-card>
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :page-sizes="[2, 5, 10, 30]"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 选择取消原因 -->
    <el-dialog
      :visible.sync="cancelReasonVisible"
      :before-close="closePop"
      title="请选择取消原因"
      width="800px"
    >
      <el-form
        ref="cancelForm"
        :model="cancelForm"
        :rules="rule"
        :inline="false"
      >
        <el-form-item
          label="取消原因"
          label-width="120px"
          prop="cancel_reason_id"
        >
          <el-select
            v-model="cancelForm.cancel_reason_id"
            clearable
            style="width: 98%"
          >
            <el-option
              v-for="(item, index) in reasonList"
              :key="index"
              :value="item.id"
              :label="item.name"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="info" @click="closePop">取消</el-button>
        <el-button size="small" type="primary" @click="cancelSub"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  meetingsearch,
  meetingcancel,
  meetingstart,
  meetingend,
  meetingStatusCount
} from '@/api/seedetails'
import {
  meetingtype,
  attendees,
  attendeesleave,
  roomData,
  downloadData
} from '@/api/conferencebooking'
import { getList } from '@/api/cancelReason'
import { searchDepartment } from '@/api/department'
import { gitusers } from '@/api/user'
import tags from '@/components/tags'
export default {
  components: {
    tags
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      checkedArr: [],
      checkedArrPage: [],
      cancelReasonVisible: false,
      cancelForm: {
        reason: '',
        cancel_reason_id: ''
      },
      rule: {
        cancel_reason_id: [
          { required: true, message: '请选择取消会议原因', trigger: 'change' }
        ]
      },
      h2List: ['参加', '请假', '早退', '拒绝'],
      statusList: [
        {
          statusName: '已预约',
          statusType: 'booking',
          value: '0'
        },
        {
          statusName: '进行中',
          statusType: 'progress',
          value: '1'
        },
        {
          statusName: '已结束',
          statusType: 'end_num',
          value: '2'
        },
        {
          statusName: '未进行',
          statusType: 'noprogress',
          value: '3'
        },
        {
          statusName: '已取消',
          statusType: 'cancel',
          value: '4'
        },
        {
          statusName: '决议处理中',
          statusType: 'resolution',
          value: '5'
        },
        {
          statusName: '已完成',
          statusType: 'complete',
          value: '7'
        },
        {
          statusName: '全部',
          statusType: 'all_num',
          value: '8'
        }
      ],
      reasonList: [],
      cancelMeetId: null,
      total: 0,
      page: 1,
      pageSize: 2,
      meetingoptions: [],
      meeting_status: [0],
      meetings: [],
      activeName: '0',
      meetingForm: {
        datatame: [],
        secrecy_type: null,
        subject: '',
        own_meeting: '1',
        meeting_no: '',
        attendee: '',
        room_id: ''
      },
      roomList: [],
      status_total: {
        booking: 0,
        progress: 0,
        end_num: 0,
        noprogress: 0,
        cancel: 0,
        complete: 0,
        resolution: 0,
        all_num: 0
      },
      isManager: false,
      mangerList: [],
      allUsers: [],
      userList: []
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  watch: {
    'meetingForm.own_meeting': function(val) {
      if (val === '') {
        this.mangerList.forEach((item) => {
          if (item.workcode === this.$store.getters.username) {
            this.isManager = true
          }
        })
      }
    }
  },
  created() {
    this.getmeetingsearch()
    meetingtype()
      .then((response) => {
        console.log(response)
        this.meetingoptions = response.data.types
      })
      .catch((err) => {
        console.log(err)
      })
    this.getReasonList()
    this.getCount()
    this.getRoomList()
    this.getManagerList()
    this.getUser()
  },
  methods: {
    // 选择框点击
    handleCheckedChange(isChecked, id) {
      if (isChecked) {
        this.checkedArr.push(id)
        this.checkedArrPage.push(id)
      } else {
        this.checkedArr.splice(this.checkedArr.indexOf(id))
        this.checkedArrPage.splice(this.checkedArrPage.indexOf(id))
      }
      const checkedCount = this.checkedArrPage.length
      this.checkAll = checkedCount === this.meetings.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.meetings.length
    },
    handleCheckAllChange(val) {
      this.meetings.forEach(item => {
        item.isChecked = val
        if (val) {
          if (this.checkedArr.indexOf(item.id) === -1) {
            this.checkedArr.push(item.id)
            this.checkedArrPage.push(item.id)
          }
        } else {
          this.checkedArr.splice(this.checkedArr.indexOf(item.id))
          this.checkedArrPage.splice(this.checkedArrPage.indexOf(item.id))
        }
      })
      this.isIndeterminate = false
    },
    exportAll(isAll) {
      const params = {
        subject: this.meetingForm.subject,
        estimate_start_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        // meeting_no: this.meetingForm.meeting_no,
        meeting_status: this.meeting_status,
        own_meeting: this.meetingForm.own_meeting,
        room_id: this.meetingForm.room_id,
        secrecy_type: this.meetingForm.secrecy_type,
        workcode: this.$store.getters.username,
        type_id: 7,
        meeting_no: isAll ? '' : this.checkedArr.join(',')
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      downloadData(params).then(res => {
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(res)
          elink.download = '早晚会表格数据.xls'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(res, '早晚会表格数据.xls')
        }
      }).catch(err => console.log(err))
    },
    // 获取会议室列表数据
    getRoomList() {
      roomData().then(res => {
        if (res.code === 'success' && res.data) {
          this.roomList = res.data
        }
      }).catch(err => console.log(err))
    },
    // 查询有配置部门权限的所有用户列表(管理员，显示工号查询)
    getManagerList() {
      this.isManager = false
      this.mangerList = []
      searchDepartment().then((res) => {
        if (res.code === 'success' && res.data.role) {
          if (res.data.role.length > 0) {
            this.mangerList = res.data.role
            console.log(this.mangerList)
          }
        }
      })
    },
    getReasonList() {
      const params = {
        page: 1,
        page_size: 1000
      }
      getList(params)
        .then((response) => {
          if (response.code === 'success' && response.data.reason.length > 0) {
            this.reasonList = response.data.reason
            this.reasonList.forEach((item) => {
              item.disabled = false
            })
          } else {
            this.reasonList = [{
              name: '尚未配置取消会议原因，请联系秘书处理！',
              disabled: true
            }]
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getUser() {
      gitusers({ departmentId: 0 })
        .then((res) => {
          if (res.code === '000000' && res.data) {
            this.allUsers = res.data
          } else {
            this.allUsers = []
          }
        })
        .catch(() => {
          this.allUsers = []
        })
    },
    filterUser(val) {
      if (val) {
        setTimeout(() => {
          this.userList = this.allUsers.filter((item) => {
            return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.userList = []
      }
    },
    onSubmit() {
      this.page = 1
      this.getCount()
      this.getmeetingsearch()
    },
    meetingstarts(item) {
      this.$confirm('确认开始早会, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          meetingstart({
            meeting_id: item.id,
            is_night: 0
          })
            .then((response) => {
              if (response.code === 'success') {
                this.meetingHandleSucces()
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    meetingHandleSucces() {
      this.$message({
        type: 'success',
        message: '成功!'
      })
      this.page = 1
      this.$store.dispatch('getMeetingRun')
      this.getmeetingsearch()
      this.getCount()
    },
    meetingends(item) {
      this.$confirm('确认结束早会, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          meetingend({
            meeting_id: item.id,
            is_night: 0
          })
            .then((response) => {
              this.meetingHandleSucces()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    handleClick(tab, event) {
      this.checkedArr = []
      this.meeting_status = tab.name === '8' ? [] : [Number(tab.name)]
      this.page = 1
      this.getmeetingsearch()
      this.getCount()
    },
    attendeesRefuse(id, type, isleave) {
      // 先判断如果是晚会请假，如果晚会已开始则提示
      const leaveString = isleave ? '请假' : '拒绝'
      if (type === '1' && id.night_start_time !== '0000-00-00 00:00:00') {
        this.$message.warning('晚会已开始，不能' + leaveString + '！')
        return
      }
      this.$confirm(
        '请先联系此会议的召集人:' + id.convenor.name + '，确认后再' + leaveString + '！',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$prompt('请输入请假内容', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputErrorMessage: '请输入' + leaveString + '原因'
          })
            .then(({ value }) => {
              const leaveParams = {
                meeting_id: id.id,
                reason: value,
                is_night: type === '0' ? 0 : 1
              }
              if (isleave) {
                attendeesleave(leaveParams)
                  .then((response) => {
                    this.$message({
                      message: '操作成功',
                      type: 'success'
                    })
                    this.getmeetingsearch()
                  })
                  .catch((err) => {
                    console.log(err)
                  })
              } else {
                attendees(leaveParams)
                  .then((response) => {
                    this.$message({
                      message: '操作成功',
                      type: 'success'
                    })
                    this.getmeetingsearch()
                  })
                  .catch((err) => {
                    console.log(err)
                  })
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    checkInfo(id) {
      this.$router.push({
        name: 'morningDetails',
        query: {
          id: id.id
        }
      })
    },
    canceltast(item) {
      this.cancelReasonVisible = true
      this.cancelMeetId = item.id
    },
    closePop() {
      this.$refs.cancelForm.resetFields()
      this.cancelReasonVisible = false
      this.cancelMeetId = ''
    },
    cancelSub() {
      this.$refs.cancelForm.validate((valid) => {
        if (valid) {
          const cancelItem = this.reasonList.find(item => item.id === this.cancelForm.cancel_reason_id)
          const reason = cancelItem ? cancelItem.name : ''
          const params = {
            meeting_id: this.cancelMeetId,
            reason: reason,
            cancel_reason_id: this.cancelForm.cancel_reason_id
          }
          meetingcancel(params)
            .then((response) => {
              if (response.code === 'success') {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                this.page = 1
                this.getmeetingsearch()
                this.getCount()
                this.closePop()
              } else {
                this.$message.error(response.message)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          return false
        }
      })
    },
    endmet(id) {
      this.$router.push({
        name: 'endemetts',
        query: {
          id: id.id,
          meeting_room_id: id.room.id
        }
      })
    },
    getmeetingsearch() {
      this.checkedArrPage = []
      const params = {
        subject: this.meetingForm.subject,
        secrecy_type: this.meetingForm.secrecy_type ? parseInt(this.meetingForm.secrecy_type) : null,
        estimate_start_time: this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time: this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        meeting_no: this.meetingForm.meeting_no,
        meeting_status: this.meeting_status,
        own_meeting: this.meetingForm.own_meeting,
        workcode: this.$store.getters.username,
        room_id: this.meetingForm.room_id,
        page: this.page,
        type_id: 7,
        page_size: this.pageSize
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      meetingsearch(params)
        .then((response) => {
          this.total = response.data.pagination.total
          const list = response.data.meetings
          // 计算自己在不在参会人之间，如果不在隐藏请假等按钮
          for (const i in list) {
            for (const j in list[i].attendees) {
              if (list[i].attendees[j].workcode === this.$store.getters.username) {
                // 在参会人中给个标识
                list[i].isAttendees = true
              }
            }
          }
          // 1、晚会开始和晚会结束：在会议预计时间当天的24点之后不再显示此两按钮
          // 2、晚会请假和晚会拒绝：在会议预计时间当天的24点之后不再显示此两按钮
          const today = new Date()
          list.forEach((item) => {
            const end_date = item.estimate_end_time.split(' ')[0] + ' 23:59:59'
            const should_date = new Date(end_date)
            item.overTime = today.getTime() > should_date.getTime()
            // 处理已选中数据的回显
            if (this.checkedArr.includes(item.id)) {
              item.isChecked = true
              this.checkedArrPage.push(item.id)
            } else {
              item.isChecked = false
            }
          })
          this.meetings = list

          const checkedCount = this.checkedArrPage.length
          this.checkAll = checkedCount === this.meetings.length
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.meetings.length
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCount() {
      const params = {
        subject: this.meetingForm.subject,
        estimate_start_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        meeting_no: this.meetingForm.meeting_no,
        meeting_status: this.meeting_status,
        own_meeting: this.meetingForm.own_meeting,
        room_id: this.meetingForm.room_id,
        secrecy_type: this.meetingForm.secrecy_type,
        workcode: this.$store.getters.username,
        type_id: 7
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      meetingStatusCount(params).then((response) => {
        if (response.code === 'success') {
          this.status_total = response.data
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getmeetingsearch()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getmeetingsearch()
    }
  }
}
</script>

<style style lang="scss" scoped>
.box-card {
  font-size: 14px;
  color: rgb(94, 90, 90);
  /* margin: 10px 15px; */
}

.title {
  font-size: 20px;
  color: #000;
}

.toolBox {
  text-align: end;
}

.footer {
  border-top: 1px solid #ebeef5;
}

.them {
  font-weight: 700;
  font-size: 14px;
}
// /deep/.el-checkbox__label {
//   display: block;
// }
</style>
